import { INSIDER_PHONE_SUPPORT_ENABLED } from "@faire/web-api--source/indigofair/settings/INSIDER_PHONE_SUPPORT_ENABLED";

import { useSetting } from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

/* This is a configuration setting that determines whether a geography has Insider phone support enabled */
export const useSettingInsiderPhoneSuppportEnabled = (): boolean =>
  useSetting(INSIDER_PHONE_SUPPORT_ENABLED, false);
